import { CheckboxGroup } from '@cian/nested-checkbox-groups';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSpecialties } from '../../../selectors/business/selectSpecialties';
import { FilterNestedCheckboxGroupsWithSearchDropdown } from '../FilterNestedCheckboxGroupsWithSearchDropdown';
import styles from './FilterBusinessAppointments.css';
import { getItemById } from './internal/helpers/getItemById';
import { getLabel } from './internal/helpers/getLabel';
import { useBusinessAppointmentsDataSelector } from './internal/hooks/useBusinessAppointmentsDataSelector';
import { useFilterBusinessAppointmentsMountEffect } from './internal/hooks/useFilterBusinessAppointmentsMountEffect';
import { HandleNestedCheckboxClick, TFilterBusinessAppointmentsProps } from './types';

const defaultLabel = 'Выберите 1 подходящую категорию';

export const FilterBusinessAppointments = React.memo(function FilterBusinessAppointments(
  props: TFilterBusinessAppointmentsProps,
) {
  const { onSelect, onBlur } = props;
  const businessAppointments = useBusinessAppointmentsDataSelector();
  const filterBusinessAppointments = useSelector(selectSpecialties);

  const filterBusinessAppointmentsIds = React.useMemo(
    () => filterBusinessAppointments.map(item => item.id),
    [filterBusinessAppointments],
  );

  const groups = React.useMemo<Array<CheckboxGroup>>(
    () =>
      businessAppointments.map(group => ({
        items: group.items.map(item => ({ label: item.name, value: item.id })),
        label: group.name,
        value: group.groupType,
      })),
    [businessAppointments],
  );

  useFilterBusinessAppointmentsMountEffect();

  const handleNestedCheckboxClick = React.useCallback<HandleNestedCheckboxClick>(
    checkboxGroupsItemChangeModel => {
      const [item] = checkboxGroupsItemChangeModel.checkboxGroupItemChangeModel.checkboxGroupChangeModel.groupItems;
      const selectedItem = getItemById(item.value, businessAppointments);

      if (selectedItem) {
        onSelect({ rusName: selectedItem.name, id: selectedItem.id, engName: selectedItem.keyName });
      }
    },
    [businessAppointments, onSelect],
  );

  // istanbul ignore next
  const handleTitleCheckboxClick = React.useCallback<VoidFunction>(() => {}, []);

  const label = getLabel(filterBusinessAppointmentsIds, groups, defaultLabel);
  const isPlaceholderLabel = label === defaultLabel;

  return (
    <div className={styles['container']}>
      <FilterNestedCheckboxGroupsWithSearchDropdown
        label={label}
        checkboxGroups={groups}
        checkboxValues={filterBusinessAppointmentsIds}
        onNestedCheckboxClick={handleNestedCheckboxClick}
        onTitleCheckboxClick={handleTitleCheckboxClick}
        isPlaceholderLabel={isPlaceholderLabel}
        onBlur={onBlur}
      />
    </div>
  );
});
